import { t } from '../i18n/index.js';
import { toast } from './toast.js';

/**
 * Service Worker anmelden (Paket P10) – nur im gebauten Stand, nicht im Vite-Entwicklungsserver. Kommt eine neue
 * Version, bietet ein Hinweis das Neuladen an (offene Änderungen bleiben im Ausgangskorb erhalten).
 */
export function registerServiceWorker() {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController) toast(t('app.update'), { ms: 30_000, action: { label: t('app.reload'), run: () => location.reload() } });
  });
  // P23: Klick auf eine Push-Nachricht bei offenem Fenster – in der App navigieren statt neu zu laden
  navigator.serviceWorker.addEventListener('message', (e) => {
    const d = e.data as { type?: string; url?: string } | null;
    if (d?.type === 'werft:open' && typeof d.url === 'string' && d.url.startsWith('/')) void import('../app/router.js').then(({ router }) => router.navigate({ href: d.url! }));
  });
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('Service Worker', e));
  });
}
